export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Sizing and Shape
                'tw-min-w-[12rem]',
                'tw-rounded-md',
                // Colors
                'tw-bg-white dark:tw-bg-gray-800',
                'tw-text-gray-800 dark:tw-text-white/80',
                'tw-border',
                { 'tw-border-gray-300 dark:tw-border-gray-600': !props.invalid },
                // Invalid State
                { 'tw-border-red-500 dark:tw-border-red-400': props.invalid },
            ],
        });
    },
    listContainer: 'tw-overflow-auto',
    list: {
        class: 'tw-py-2 tw-list-none tw-m-0 tw-outline-none',
    },
    option: function (_a) {
        var props = _a.props, context = _a.context;
        return ({
            class: [
                'tw-relative',
                // Font
                'tw-font-normal',
                'tw-text-base',
                'tw-leading-none',
                // Flex
                'tw-flex tw-items-center',
                // Position
                'tw-relative',
                // Shape
                'tw-border-0',
                'tw-rounded-none',
                // Spacing
                'tw-m-0',
                'tw-py-2 tw-px-3',
                // Colors
                {
                    'tw-text-gray-800 dark:tw-text-white/80': !context.focused && !context.selected,
                    'hover:tw-bg-gray-200 dark:hover:tw-bg-gray-600/60': context.focused && !context.selected,
                    'tw-bg-primary-500 tw-text-white': context.selected,
                },
                //States
                {
                    'hover:tw-bg-gray-100 hover:tw-text-gray-800 dark:hover:tw-bg-gray-600/80': !context.focused && !context.selected,
                },
                // { 'hover:bg-highlight-emphasis': context.selected && !props.checkmark },
                'focus-visible:tw-outline-none focus-visible:tw-outline-offset-0 focus-visible:tw-ring focus-visible:tw-ring-inset focus-visible:tw-ring-primary-400/50 dark:focus-visible:tw-ring-primary-300/50',
                // Transitions
                'tw-transition',
                'tw-duration-200',
                // Misc
                'tw-cursor-pointer',
                'tw-overflow-hidden',
                'tw-whitespace-nowrap',
            ],
        });
    },
    optionCheckIcon: 'tw-relative tw--ms-1.5 tw-me-2 tw-size-3 tw-min-w-3',
    emptyMessage: {
        class: [
            // Font
            'tw-leading-none',
            // Spacing
            'tw-py-3 tw-px-4',
            // Color
            'tw-text-gray-800 dark:tw-text-white/80',
            'tw-bg-transparent',
        ],
    },
};
